module.exports = require('./promisify')(require('bluebird'))


//////////////////
// WEBPACK FOOTER
// ./~/img-async/index.js
// module id = 224
// module chunks = 0